import { CloudCog } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const McpConfigIcon = DeckardIconWrapper({ Icon: CloudCog });
